<template>
    <router-link
        v-if="to"
        v-slot="{href: linkHref, isExactActive, navigate}"
        :to="to"
    >
        <a
            :class="['menu-dropdown-item', stateClasses, {active: isExactActive}]"
            :href="linkHref"
            @click="navigate"
        >
            <FontAwesomeIcon
                v-if="active || isExactActive"
                class="icon"
                icon="arrow-right"
            />

            <!-- Content to be displayed if the item is an internal link -->
            <slot />
        </a>
    </router-link>

    <a
        v-else-if="href"
        :class="['menu-dropdown-item', stateClasses]"
        :href="href"
        :rel="rel"
        :target="target"
    >
        <FontAwesomeIcon
            v-if="active"
            class="icon"
            icon="arrow-right"
        />

        <!-- Content to be displayed if the item is an custom/external link -->
        <slot />
    </a>

    <button
        v-else
        :class="['menu-dropdown-item', stateClasses]"
        @click="$emit('click', $event)"
    >
        <span>
            <FontAwesomeIcon
                v-if="active"
                class="icon"
                icon="arrow-right"
            />

            <!-- Content to be displayed if the item is a button -->
            <slot />
        </span>
    </button>
</template>

<script>
    import {library} from '@fortawesome/fontawesome-svg-core';
    import {faArrowRight} from '@fortawesome/pro-solid-svg-icons';
    import {FontAwesomeIcon} from '@fortawesome/vue-fontawesome';

    library.add(faArrowRight);

    /**
     * @group Layout
     * A component to display a Menu Dropdown Item; to be used inside
     * a `MenuItem`'s `dropdown-items` slot.
     */
    export default {
        name: 'MenuDropdownItem',
        components: {
            FontAwesomeIcon,
        },
        inject: {
            parentInternal: 'internal',
        },
        props: {
            /**
             * When set to `true`, places the component in the active state with active styling
             */
            active: {
                type: Boolean,
                required: false,
                // `false`
                default: false,
            },
            /**
             * When set, turns the component into a custom/external link and sets the `href`
             * attribute of that link
             */
            href: {
                type: String,
                required: false,
                // `undefined`
                default: undefined,
            },
            /**
             * When set to `true`, places the component in the internal state with internal styling
             */
            internal: {
                type: Boolean,
                required: false,
                // `false`
                default: false,
            },
            /**
             * Sets the `rel` attribute of the custom/external link
             */
            rel: {
                type: String,
                required: false,
                // `undefined`
                default: undefined,
            },
            /**
             * Sets the `target` attribute of the custom/external link
             */
            target: {
                type: String,
                required: false,
                // `undefined`
                default: undefined,
            },
            /**
             * When set, turns the component into a `router-link`/internal link and sets the
             * `to` prop of that link
             */
            to: {
                type: [String, Object],
                required: false,
                // `undefined`
                default: undefined,
            },
        },
        computed: {
            stateClasses() {
                return {active: this.active, internal: this.internal || this.parentInternal};
            },
        },
    };
</script>
